import React from "react";

export default function Wait(props) {
    // const refWait = React.useRef(null);

    React.useEffect(() => {
        const dom = document.createElement("div");
        document.body.appendChild(dom);

        if (props.show && props.show !== true) {
            dom.innerHTML = props.show;
        } else if (!props.show) {
            dom.innerHTML = "";
        }

        const CNWait = ["wait"];
        props.show && CNWait.push("show");
        dom.classList.add(...CNWait);

        return () => {
            if (dom.parentElement) {
                dom.parentElement.removeChild(dom);
            }
        };
    }, [props.show]);

    // return <div ref={refWait} className={CNWait.join(" ")}></div>;
    return null;
}
